import { useMutation, useQueryClient } from "@tanstack/react-query";

import type { AccountSignalSettings } from "app/pages/sales-intelligence/sub-modules/signals/services/api/factory";
import salesApiService from "app/pages/sales-intelligence/services/salesApiService";

import { signalsQueryKeys } from "../key-factory";

export const useUpdateAccountSignalSettingsMutation = () => {
    const queryClient = useQueryClient();

    return useMutation<
        AccountSignalSettings,
        Error,
        AccountSignalSettings,
        { previousSettings?: AccountSignalSettings }
    >({
        mutationFn: (settings: AccountSignalSettings): Promise<AccountSignalSettings> => {
            return salesApiService.signals.updateAccountSettings(settings);
        },
        onMutate: async (newSettings) => {
            await queryClient.cancelQueries({
                queryKey: signalsQueryKeys.accountSettings(),
            });

            const previousSettings = queryClient.getQueryData<AccountSignalSettings>(
                signalsQueryKeys.accountSettings(),
            );

            queryClient.setQueryData(signalsQueryKeys.accountSettings(), newSettings);

            return { previousSettings };
        },
        onError: (_err, _newSettings, context) => {
            if (context?.previousSettings) {
                queryClient.setQueryData(signalsQueryKeys.accountSettings(), context.previousSettings);
            }
        },
        onSettled: () => {
            void queryClient.invalidateQueries({
                queryKey: signalsQueryKeys.accountSettings(),
            });
        },
    });
};
